// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/packaging-3/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produktePackaging3EN: PageEntry = {
  id: "example.en-produkte-packaging-3",
  locale: "en",
  slug: "produkte/packaging-3",
  seo: {
    title: "Packaging 3 | Dietz GmbH",
    description: "Packaging 3",
  },
  type: "post",
  h1: "Packaging 3",
  intro: "Packaging 3",
  blocks: [
    { kind: "image", src: "/images/live/verpackung-image003.png", alt: "Packaging 3", width: 600, height: 440 }
  ],
};
